import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner, Toast, ToastContainer } from "react-bootstrap";

import { TextInput } from "../../../shared/form/FormInput";
import { Validators } from "../../../shared/utils/Validators";
import { RenderAppLogo, RenderNoAuthHeaderText } from "../../../shared/components/ConditonalComponent";

import { resetPassword } from "../../../shared/settings/apiConfig";
import { postApi } from "../../../shared/services/apiHelper";

import '../NoAuth.scss';

export default function ForgotPassword(props) {
    const [state, setState] = useState({
        formControls: {
            email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
        },
        formValid: false,
        formLoading: false,
        message:{note:"",type:"",show:false}
    })
    const [width, setwidth] = useState()
    useEffect(() => {
        window.addEventListener('resize', () => {
            setwidth(window.innerWidth)
        });

        return () => {

        }
    }, [])
    const onInputChange = (controlName, event) => {
        let data = { ...state }
        data["formControls"][controlName] = Validators.validateFormControl(state.formControls[controlName], event.target.value)
        data["formValid"] = Validators.validateForm(data["formControls"])
        setState(data)
    }
    const sendLink = () => {
        setState({ ...state, formLoading: true })
        const payload = {
            data: {
                email: state?.formControls?.email?.value
            }
        };
        postApi(resetPassword, payload, false).then(response => {
            setState({ ...state, 
                formLoading: false,
                message:{note:response?.data?.message,type:response?.data?.status,show:true}
             })
             setTimeout(() => {
                setState({ ...state, 
                    formLoading: false,
                    message:{note:"",type:"",show:false}
                 })
                 props.history.push('sign-in')
             }, 3000);
           
           
        }).catch(error => {
            setState({ ...state, 
                message:{msg:JSON.stringify(error?.response?.message),type:"danger"}
             })
             setTimeout(() => {
                setState({ ...state, 
                    message:{note:"",type:"",show:false}
                 })
             }, 3000);
        });
    }
    return (
        <div className="forgot-password w-100" >
            <img class="noauth-bg-img" src={`${process.env.PUBLIC_URL}/static/images/forgotscreenbg.png`} alt="bg" />
            <div className='scontainer my-2'>
                <RenderAppLogo />

                <div className='sigincontent'>
                    <div class="shadow-lg pd-x-5 rounded">
                        <div class="w-100 d-flex justify-content-center flex-column">
                            <RenderNoAuthHeaderText />
                            <div className="pt-5 w-100">
                                <h4 className="w-100" style={{ fontWeight: "bolder", color: "#5c2e91", margin: "15px" }}>Forgot Password</h4>
                                <div class="  rounded w-100 d-flex flex-column justify-content-center align-items-center p-3 ">
                                    <div className="w-100">
                                        <TextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}
                                            value={state.formControls.email.value} error={state.formControls.email.error} onChange={(event) => { onInputChange('email', event); }} />
                                        <div className=" w-100 my-4">
                                            <button type="button" className="d-flex align-items-center justify-content-center btn btn-secondary sign-btn w-100" onClick={() => { sendLink() }} disabled={!state.formValid}>Send password Link {state.formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</button>
                                            <p className="py-2 ">Back to <Link to="/sign-in" ><span className='text-primary' style={{ fontWeight: "bolder" }}> Log in</span></Link>?</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='footer-section'>
                <a href="https://image.assessmax.com/assessmax/PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a> <span style={{ fontWeight: 'bold' }}>|</span>
                <a href="https://image.assessmax.com/assessmax/TermsandConditionsAcceptableandfairUsage.pdf" target="_blank" rel="noopener noreferrer"> Terms and Conditions</a>
            </footer>
            <ToastContainer position="top-end" className="p-3 text-white" style={{ zIndex: 1 }} >
                <Toast show={state?.message?.show} bg={state?.message?.type} autohide={true} delay={2000}>
                    <Toast.Body>
                        {state?.message?.note}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    )
}